<div @tooltip #mainContainer class="main-container">
  {{ text }}
  @for (option of listData; track option) {
  <div class="p-0">
    <b>{{ option.title }}:</b> {{ option.value }}<br />
  </div>
  }
</div>
